/* query param name indicates which settings module is expanded if any */
export const EXPANDED = 'expanded';
export const SETTINGS_OPEN_QUERY_VALUE = 'settings';